//@flow
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Image } from 'components/atoms/image';
import Dotdotdot from 'react-dotdotdot';
import { StringUtil } from 'utils/StringUtil';
import { CallToAction } from 'components/atoms/callToAction';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles.scss';

type Props = {
  onClick: void,
  infoLinks: Array,
};

export const OurDifferenceMobMultiCarousel = (props: Props) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [firstSlider, setFirstSlider] = useState();
  const [secondSlider, setSecondSlider] = useState();
  const [overlay_page_data, set_overlay_page_data] = useState({});
  const [show_overlay_button, set_show_overlay_button] = useState(false);
  const {
    infoLinks,
    cssFor,
    cmsDetailsData,
    renderOverlayPage,
    overlay_data,
  } = props;

  useEffect(() => {
    if (cmsDetailsData) {
      checkOverlayCorrespondingFeature(activeSlide);
    }
  }, [activeSlide]);

  if (!infoLinks) {
    return null;
  }

  const checkOverlayCorrespondingFeature = selected_id => {
    let data = {};
    set_overlay_page_data(data);
    set_show_overlay_button(false);
    Object.values(cmsDetailsData).map((data, idx) => {
      if (infoLinks[selected_id].cms_page_id === data.cms_page_id) {
        set_overlay_page_data(data);
        set_show_overlay_button(true);
        return;
      }
    });
  };

  const settings = {
    className: 'slider variable-width',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next),
    arrows: false,
    draggable: true,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const settings2 = {
    className: 'slider variable-width',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 1000,
    arrows: false,
    draggable: true,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const renderOverlayButton = () => {
    return (
      <div className={'explore'}>
        <CallToAction
          text={'LEARN MORE'}
          mode={'transparent'}
          type={'link'}
          onClick={() => (
            renderOverlayPage(true), overlay_data(overlay_page_data)
          )}
          size={'small'}
          isMobile="true"
        />
      </div>
    );
  };

  const renderFirstCarousel = () => {
    return (
      <div className={'first-carousel'}>
        <Slider
          asNavFor={secondSlider}
          ref={d => setFirstSlider(d)}
          {...settings}
        >
          {infoLinks.map((features, idx) => {
            return (
              <div
                className={`our-difference-features ${activeSlide === idx &&
                  'active-tab'}`}
              >
                <span className={`${activeSlide === idx && 'active-tab'}`}>
                  {features.title}
                </span>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  };

  const renderSecondCarousel = () => {
    return (
      <div className={'carousel-second'}>
        <Slider
          asNavFor={firstSlider}
          ref={c => setSecondSlider(c)}
          {...settings2}
        >
          {infoLinks.map((features, idx) => {
            return (
              <div className={'second-carousel'}>
                <div className="feature-img">
                  <Image src={`${features.data.mobile_image}`} alt="img" />
                </div>
                <div className="our-difference-content">
                  <h3>{features.data.page_title}</h3>
                  <div className={'feature-description-container'}>
                    <Dotdotdot
                      clamp={7}
                      tagName={'p'}
                      className={'our-difference-description'}
                    >
                      {StringUtil.sliceHtml(features.data.short_mobile_content)}
                    </Dotdotdot>
                    {show_overlay_button ? renderOverlayButton() : null}
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  };

  return (
    <div className={cssFor}>
      {renderFirstCarousel()}
      {renderSecondCarousel()}
    </div>
  );
};
